const CATEGORIES = [
  { // 96
    id: "96_exit",
    type: "cape",
    title: "96 Exit",
    desc: `There isn't a category named '100%' in SMW, but this is generally accepted to be full completion run of the game. As stated below, this category necessitates the completion of all 96 of the game's intended exits (there are ways to increment the exit count on the title screen by the use of various glitches).`,
    leaderboard: `?h=96_Exit&x=7kjrn323`,
    route: [
      `Yoshi's Island 2`,
      `Yoshi's Island 3`,
      `Yoshi's Island 4`,
      `#1 Iggy's Castle`,
      `Donut Plains 1 (Secret)`,
      `Donut Secret 1`,
      `Donut Ghost House (Secret)`,
      `Donut Secret 1 (Secret)`,
      `Donut Secret House (Secret)`,
      `Donut Secret House`,
      `Donut Secret 2`,
      `Donut Plains 3`,
      `Donut Plains 4`,
      `#2 Morton's Castle`,
      `Vanilla Dome 1`,
      `Vanilla Dome 2 (Secret)`,
      `Red Switch Palace`,
      `Vanilla Dome 2`,
      `Vanilla Ghost House`,
      `Vanilla Dome 3`,
      `Vanilla Dome 4`,
      `#3 Lemmy's Castle`,
      `Cheese Bridge Area`,
      `Cookie Mountain`,
      `Cheese Bridge Area (Secret)`,
      `Soda Lake`,
      `Star World 3 (Secret)`,
      `Star World 4`,
      `Star World 4 (Secret)`,
      `Star World 5`,
      `Star World 1 (Secret)`,
      `Star World 2 (Secret)`,
      `Star World 3`,
      `Star World 2`,
      `Star World 1`,
      `Star World 5 (Secret)`,
      `Gnarly`,
      `Tubular`,
      `Way Cool`,
      `Awesome`,
      `Groovy`,
      `Mondo`,
      `Outrageous`,
      `Funky`,
      `Yoshi's Island 1`,
      `Yellow Switch Palace`,
      `Donut Plains 1`,
      `Donut Plains 2 (Secret)`,
      `Green Switch Palace`,
      `Donut Plains 2`,
      `Donut Ghost House`,
      `Vanilla Dome 1 (Secret)`,
      `Vanilla Secret 1 (Secret)`,
      `Vanilla Secret 1`,
      `Vanilla Secret 2`,
      `Vanilla Secret 3`,
      `Vanilla Fortress`,
      `Butter Bridge 1`,
      `Butter Bridge 2`,
      `#4 Ludwig's Castle`,
      `Forest of Illusion 1`,
      `Forest of Illusion 2 (Secret)`,
      `Blue Switch Palace`,
      `Forest of Illusion 1 (Secret)`,
      `Forest Ghost House (Secret)`,
      `Forest of Illusion 2`,
      `Forest of Illusion 3`,
      `Forest Ghost House`,
      `Forest of Illusion 4 (Secret)`,
      `Forest Secret Area`,
      `Forest Fortress`,
      `Forest of Illusion 4`,
      `Forest of Illusion 3 (Secret)`,
      `#5 Roy's Castle`,
      `Chocolate Island 1`,
      `Choco-Ghost House`,
      `Chocolate Island 2 (Secret)`,
      `Chocolate Secret`,
      `Chocolate Island 2`,
      `Chocolate Island 3`,
      `Chocolate Island 3 (Secret)`,
      `Chocolate Fortress`,
      `Chocolate Island 4`,
      `Chocolate Island 5`,
      `#6 Wendy's Castle`,
      `Sunken Ghost Ship`,
      `Valley of Bowser 1`,
      `Valley of Bowser 2`,
      `Valley Ghost House (Secret)`,
      `Valley Ghost House`,
      `Valley of Bowser 3`,
      `Valley of Bowser 4 (Secret)`,
      `Valley of Bowser 4`,
      `#7 Larry's Castle`,
      `Valley of Bowser 2 (Secret)`,
      `Valley Fortress`,
      `Back Door`
    ],
    rules: [
      `Time begins the frame Mario appears in the opening cutscene. This is 2.2 seconds after selecting 1 Player Game.`,
      `Time ends on the frame that Peach appears outside of Bowser's Clown Car.`,
      `Clear every intended Exit.`,
      `No Arbitrary Code Execution.`,
      `No Orb/Cloud.`,
      `A post-run "file check" is strongly encouraged, but not required.`
    ],
    penalties: [],
    wr: "/category/7kjrn323?top=1",
    top15: "/category/7kjrn323?top=15"
  },
  { // ac
    id: "ac",
    type: "cape",
    title: "All Castles",
    desc: `This category serves as an alternative 'warpless' type run to No Starworld. Runners generally agree that this is a more fun route to NSW because this route excludes Butter Bridge 1 and includes more fun levels such as Vanilla Dome 3. In all, there are 33 exits to complete in this run.`,
    leaderboard: `?h=All_Castles&x=02qjj79d`,
    route: [
      `Yoshi's Island 2`,
      `Yoshi's Island 3`,
      `Yoshi's Island 4`,
      `#1 Iggy's Castle`,
      `Donut Plains 1 (Secret)`,
      `Donut Secret 1`,
      `Donut Ghost House`,
      `Donut Plains 3`,
      `Donut Plains 4`,
      `#2 Morton's Castle`,
      `Vanilla Dome 1`,
      `Vanilla Dome 2`,
      `Vanilla Ghost House`,
      `Vanilla Dome 3`,
      `Vanilla Dome 4`,
      `#3 Lemmy's Castle`,
      `Cheese Bridge Area`,
      `Cookie Mountain`,
      `#4 Ludwig's Castle`,
      `Forest of Illusion 1`,
      `Forest of Illusion 2`,
      `Forest of Illusion 3 (Secret)`,
      `#5 Roy's Castle`,
      `Chocolate Island 1`,
      `Choco-Ghost House`,
      `Chocolate Island 2 (Secret)`,
      `Chocolate Secret`,
      `#6 Wendy's Castle`,
      `Sunken Ghost Ship`,
      `Valley of Bowser 1`,
      `Valley of Bowser 2`,
      `Valley Ghost House (Secret)`,
      `#7 Larry's Castle`,
      `Front Door`
    ],
    rules: [
      `Time begins the frame Mario appears in the opening cutscene. This is 2.2 seconds after selecting 1 Player Game.`,
      `Time ends on the frame that Peach appears outside of Bowser's Clown Car.`,
      `Complete all 8 castles as quickly as possible.`,
      `No Arbitrary Code Execution.`,
      `No Orb/Cloud.`,
      `No Submap Warp.`
    ],
    penalties: [],
    wr: "/category/02qjj79d?top=1",
    top15: "/category/02qjj79d?top=15"
  },
  { // nsw
    id: "nsw",
    type: "cape",
    title: "No Starworld",
    desc: `No Starworld was the most popular 'warpless' type run until early 2016. This route takes the fastest path to Bowser without the use of Star World. In all, there are 31 exits to complete in this run.`,
    leaderboard: `?h=No_Starworld&x=zdn1jxkq`,
    route: [
      `Yoshi's Island 2`,
      `Yoshi's Island 3`,
      `Yoshi's Island 4`,
      `#1 Iggy's Castle`,
      `Donut Plains 1 (Secret)`,
      `Donut Secret 1`,
      `Donut Ghost House`,
      `Donut Plains 3`,
      `Donut Plains 4`,
      `#2 Morton's Castle`,
      `Vanilla Dome 1 (Secret)`,
      `Vanilla Secret 1 (Secret)`,
      `Vanilla Secret 2`,
      `Vanilla Secret 3`,
      `Vanilla Fortress`,
      `Butter Bridge 1`,
      `Butter Bridge 2`,
      `#4 Ludwig's Castle`,
      `Forest of Illusion 1`,
      `Forest of Illusion 2`,
      `Forest of Illusion 3 (Secret)`,
      `#5 Roy's Castle`,
      `Chocolate Island 1`,
      `Choco-Ghost House`,
      `Chocolate Island 2 (Secret)`,
      `Chocolate Secret`,
      `#6 Wendy's Castle`,
      `Sunken Ghost Ship`,
      `Valley of Bowser 1`,
      `Valley of Bowser 2 (Secret)`,
      `Valley Fortress`,
      `Back Door`
    ],
    rules: [
      `Time begins the frame Mario appears in the opening cutscene. This is 2.2 seconds after selecting 1 Player Game.`,
      `Time ends on the frame that Peach appears outside of Bowser's Clown Car.`,
      `No Arbitrary Code Execution.`,
      `No Orb/Cloud.`,
      `No Starworld allowed.`,
      `No Submap Warp.`
    ],
    penalties: [],
    wr: "/category/zdn1jxkq?top=1",
    top15: "/category/zdn1jxkq?top=15"
  },
  { // 11
    id: "11_exit",
    type: "cape",
    title: "11 Exit",
    desc: `There isn't a category named 'Any%' in SMW, but this was generally accepted to be the equivalent until the discovery of 0 Exit. Since then, category names with percentages have been dropped to avoid confusion and debate. This category takes the shortest overworld path to Bowser, through Star World. There are three variants of this category: Cloud, Orb, and Glitchless. Cloud and Orb are two glitches used to skip parts of the run (Bowser's movements in the final fight and Iggy's Castle, respectively).`,
    leaderboard: `?h=11_Exit-cloud&x=n2y1y72o-yn2wxjn5.z19e7yq4`,
    route: [
      `Yoshi's Island 2`,
      `Yoshi's Island 3`,
      `Yoshi's Island 4`,
      `#1 Iggy's Castle`,
      `Donut Plains 1 (Secret)`,
      `Donut Secret 1 (Secret)`,
      `Donut Ghost House (Secret)`,
      `Star World 1 (Secret)`,
      `Star World 2 (Secret)`,
      `Star World 3 (Secret)`,
      `Star World 4 (Secret)`,
      `Front Door`
    ],
    rules: [
      `Time begins the frame Mario appears in the opening cutscene. This is 2.2 seconds after selecting 1 Player Game.`,
      `Time ends on the frame that Peach appears outside of Bowser's Clown Car.`,
      `No Arbitrary Code Execution. (More specifically, not letting the instruction pointer hit anywhere but ROM, open bus, and the intended RAM area ($7F8000-$7F8182), and no modifying the inteded RAM area).`,
      `No Credits Warp.`
    ],
    penalties: [],
    wr: "/category/n2y1y72o?top=1",
    top15: "/category/n2y1y72o?top=15"
  },
  { // 0
    id: "0_exit",
    type: "other",
    title: "0 Exit",
    desc: `This category skips the completion of any exits, and warps straight to the credits from Yoshi's Island 2 by use of Arbitrary Code Execution (ACE).`,
    leaderboard: `?h=0_Exit&x=wkpjpzjk`,
    route: [
      `Yoshi's Island 2`
    ],
    rules: [
      `Time begins the frame Mario appears in the opening cutscene. This is 2.2 seconds after selecting 1 Player Game.`,
      `Time ends when player loses control for credits warp. This is the first duplicate frame after performing the item swap (the frame before the screen starts to get darker).`,
      `All glitches allowed.`,
      `Video is required.`
    ],
    penalties: [],
    wr: "/category/wkpjpzjk?top=1",
    top15: "/category/wkpjpzjk?top=15"
  },
  { // 95nc
    id: "95nc",
    type: "no-cape",
    title: "95 Exit, No Cape",
    desc: `This is the no cape variant of 96 Exit. It is impossible to complete Donut Ghost House secret exit without cape, which is why this category isn't '96 Exit, No Cape'.`,
    leaderboard: `?h=95_Exit_No_Cape&x=ndx31odq`,
    route: [
      `Yoshi's Island 2`,
      `Yoshi's Island 3`,
      `Yoshi's Island 4`,
      `#1 Iggy's Castle`,
      `Donut Plains 1 (Secret)`,
      `Donut Secret 1`,
      `Donut Secret 1 (Secret)`,
      `Donut Secret House`,
      `Donut Secret 2`,
      `Donut Secret House (Secret)`,
      `Star World 1`,
      `Star World 1 (Secret)`,
      `Star World 2 (Secret)`,
      `Star World 3`,
      `Star World 3 (Secret)`,
      `Star World 4`,
      `Star World 4 (Secret)`,
      `Star World 5`,
      `Star World 5 (Secret)`,
      `Gnarly`,
      `Tubular`,
      `Way Cool`,
      `Awesome`,
      `Groovy`,
      `Mondo`,
      `Outrageous`,
      `Funky`,
      `Yoshi's Island 1`,
      `Yellow Switch Palace`,
      `Donut Plains 1`,
      `Donut Plains 2 (Secret)`,
      `Green Switch Palace`,
      `Donut Plains 2`,
      `Donut Ghost House`,
      `Donut Plains 3`,
      `Donut Plains 4`,
      `#2 Morton's Castle`,
      `Vanilla Dome 1 (Secret)`,
      `Vanilla Secret 1 (Secret)`,
      `Vanilla Dome 1`,
      `Vanilla Dome 2 (Secret)`,
      `Red Switch Palace`,
      `Vanilla Dome 2`,
      `Vanilla Ghost House`,
      `Vanilla Dome 3`,
      `Vanilla Dome 4`,
      `#3 Lemmy's Castle`,
      `Cheese Bridge Area`,
      `Cookie Mountain`,
      `Cheese Bridge Area (Secret)`,
      `Soda Lake`,
      `Star World 2`,
      `Vanilla Secret 1`,
      `Vanilla Secret 2`,
      `Vanilla Secret 3`,
      `Vanilla Fortress`,
      `Butter Bridge 1`,
      `Butter Bridge 2`,
      `#4 Ludwig's Castle`,
      `Forest of Illusion 1 (Secret)`,
      `Forest Ghost House`,
      `Forest of Illusion 4 (Secret)`,
      `Forest Secret Area`,
      `Forest Fortress`,
      `Forest of Illusion 4`,
      `Forest of Illusion 2`,
      `Forest of Illusion 3`,
      `Forest Ghost House (Secret)`,
      `Forest of Illusion 1`,
      `Forest of Illusion 2 (Secret)`,
      `Blue Switch Palace`,
      `Forest of Illusion 3 (Secret)`,
      `#5 Roy's Castle`,
      `Chocolate Island 1`,
      `Choco-Ghost House`,
      `Chocolate Island 2 (Secret)`,
      `Chocolate Secret`,
      `Chocolate Island 2`,
      `Chocolate Island 3`,
      `Chocolate Island 3 (Secret)`,
      `Chocolate Fortress`,
      `Chocolate Island 4`,
      `Chocolate Island 5`,
      `#6 Wendy's Castle`,
      `Sunken Ghost Ship`,
      `Valley of Bowser 1`,
      `Valley of Bowser 2`,
      `Valley Ghost House (Secret)`,
      `Valley Ghost House`,
      `Valley of Bowser 3`,
      `Valley of Bowser 4 (Secret)`,
      `Valley of Bowser 4`,
      `#7 Larry's Castle`,
      `Valley of Bowser 2 (Secret)`,
      `Valley Fortress`,
      `Back Door`
    ],
    rules: [
      `Time begins the frame Mario appears in the opening cutscene. This is 2.2 seconds after selecting 1 Player Game.`,
      `Time ends on the frame that Peach appears outside of Bowser's Clown Car.`,
      `Complete every goal possible without a cape (Donut Ghost House, secret exit is not possible).`,
      `A post-run "file check" is strongly encouraged, but not required.`
    ],
    penalties: [
      `If a cape is obtained, die as soon as possible without utilizing it.`
    ],
    wr: "/category/ndx31odq?top=1",
    top15: "/category/ndx31odq?top=15"
  },
  { // acnc
    id: "acnc",
    type: "no-cape",
    title: "All Castles, No Cape",
    desc: `This is the no cape variant of All Castles`,
    leaderboard: `?h=All_Castles_No_Cape&x=5dw75lgk`,
    route: [
      `Yoshi's Island 2`,
      `Yoshi's Island 3`,
      `Yoshi's Island 4`,
      `#1 Iggy's Castle`,
      `Donut Plains 1 (Secret)`,
      `Donut Secret 1`,
      `Donut Ghost House`,
      `Donut Plains 3`,
      `Donut Plains 4`,
      `#2 Morton's Castle`,
      `Vanilla Dome 1`,
      `Vanilla Dome 2`,
      `Vanilla Ghost House`,
      `Vanilla Dome 3`,
      `Vanilla Dome 4`,
      `#3 Lemmy's Castle`,
      `Cheese Bridge Area`,
      `Cookie Mountain`,
      `#4 Ludwig's Castle`,
      `Forest of Illusion 1`,
      `Forest of Illusion 2`,
      `Forest of Illusion 3 (Secret)`,
      `#5 Roy's Castle`,
      `Chocolate Island 1`,
      `Choco-Ghost House`,
      `Chocolate Island 2 (Secret)`,
      `Chocolate Secret`,
      `#6 Wendy's Castle`,
      `Sunken Ghost Ship`,
      `Valley of Bowser 1`,
      `Valley of Bowser 2`,
      `Valley Ghost House (Secret)`,
      `#7 Larry's Castle`,
      `Front Door`
    ],
    rules: [
      `Time begins the frame Mario appears in the opening cutscene. This is 2.2 seconds after selecting 1 Player Game.`,
      `Time ends on the frame that Peach appears outside of Bowser's Clown Car.`,
      `Complete all 8 castles as quickly as possible.`,
      `No Arbitrary Code Execution.`,
      `No Cape.`,
      `No Orb/Cloud.`,
      `No Submap Warp.`
    ],
    penalties: [
      `If a cape is obtained, die as soon as possible without utilizing it.`
    ],
    wr: "/category/5dw75lgk?top=1",
    top15: "/category/5dw75lgk?top=15"
  },
  { // ncnsw
    id: "ncnsw",
    type: "no-cape",
    title: "No Cape, No Starworld",
    desc: `This is the no cape variant of No Starworld.`,
    leaderboard: `?h=No_Cape_No_Starworld&x=q257ngdo`,
    route: [
      `Yoshi's Island 2`,
      `Yoshi's Island 3`,
      `Yoshi's Island 4`,
      `#1 Iggy's Castle`,
      `Donut Plains 1 (Secret)`,
      `Donut Secret 1`,
      `Donut Ghost House`,
      `Donut Plains 3`,
      `Donut Plains 4`,
      `#2 Morton's Castle`,
      `Vanilla Dome 1 (Secret)`,
      `Vanilla Secret 1 (Secret)`,
      `Vanilla Secret 2`,
      `Vanilla Secret 3`,
      `Vanilla Fortress`,
      `Butter Bridge 1`,
      `Butter Bridge 2`,
      `#4 Ludwig's Castle`,
      `Forest of Illusion 1`,
      `Forest of Illusion 2`,
      `Forest of Illusion 3 (Secret)`,
      `#5 Roy's Castle`,
      `Chocolate Island 1`,
      `Choco-Ghost House`,
      `Chocolate Island 2 (Secret)`,
      `Chocolate Secret`,
      `#6 Wendy's Castle`,
      `Sunken Ghost Ship`,
      `Valley of Bowser 1`,
      `Valley of Bowser 2 (Secret)`,
      `Valley Fortress`,
      `Back Door`
    ],
    rules: [
      `Time begins the frame Mario appears in the opening cutscene. This is 2.2 seconds after selecting 1 Player Game.`,
      `Time ends on the frame that Peach appears outside of Bowser's Clown Car.`,
      `No Arbitrary Code Execution.`,
      `No Cape.`,
      `No Orb/Cloud.`,
      `No Starworld.`
    ],
    penalties: [
      `If a cape is obtained, die as soon as possible without utilizing it.`
    ],
    wr: "/category/q257ngdo?top=1",
    top15: "/category/q257ngdo?top=15"
  },
  { // 11nc
    id: "11nc",
    type: "no-cape",
    title: "11 Exit, No Cape",
    desc: `This is the no cape variant of 11 Exit. Similar to 11 Exit, there are three variants of 11NC: Cloud, Orb, and Glitchless.`,
    leaderboard: `?h=11_Exit_No_Cape-cloud&x=mkeyen26-wl3z46n1.81495rjq`,
    route: [
      `Yoshi's Island 2`,
      `Yoshi's Island 3`,
      `Yoshi's Island 4`,
      `#1 Iggy's Castle`,
      `Donut Plains 1 (Secret)`,
      `Donut Secret 1 (Secret)`,
      `Donut Ghost House (Secret)`,
      `Star World 1 (Secret)`,
      `Star World 2 (Secret)`,
      `Star World 3 (Secret)`,
      `Star World 4 (Secret)`,
      `Front Door`
    ],
    rules: [
      `Time begins the frame Mario appears in the opening cutscene. This is 2.2 seconds after selecting 1 Player Game.`,
      `Time ends on the frame that Peach appears outside of Bowser's Clown Car.`,
      `No Arbitrary Code Execution.`,
      `No Cape.`
    ],
    penalties: [
      `If a cape is obtained, die as soon as possible without utilizing it.`
    ],
    wr: "/category/mkeyen26?top=1",
    top15: "/category/mkeyen26?top=15"
  },
  { // acso
    id: "acso",
    type: "small-only",
    title: "All Castles, Small Only",
    desc: `This is the small only variant of All Castles.`,
    leaderboard: `?h=All_Castles_Small_Only&x=wk6v75ed`,
    route: [
      `Yoshi's Island 2`,
      `Yoshi's Island 3`,
      `Yoshi's Island 4`,
      `#1 Iggy's Castle`,
      `Donut Plains 1 (Secret)`,
      `Donut Secret 1`,
      `Donut Ghost House`,
      `Donut Plains 3`,
      `Donut Plains 4`,
      `#2 Morton's Castle`,
      `Vanilla Dome 1`,
      `Vanilla Dome 2`,
      `Vanilla Ghost House`,
      `Vanilla Dome 3`,
      `Vanilla Dome 4`,
      `#3 Lemmy's Castle`,
      `Cheese Bridge Area`,
      `Cookie Mountain`,
      `#4 Ludwig's Castle`,
      `Forest of Illusion 1`,
      `Forest of Illusion 2`,
      `Forest of Illusion 3 (Secret)`,
      `#5 Roy's Castle`,
      `Chocolate Island 1`,
      `Choco-Ghost House`,
      `Chocolate Island 2 (Secret)`,
      `Chocolate Secret`,
      `#6 Wendy's Castle`,
      `Sunken Ghost Ship`,
      `Valley of Bowser 1`,
      `Valley of Bowser 2`,
      `Valley Ghost House (Secret)`,
      `#7 Larry's Castle`,
      `Front Door`
    ],
    rules: [
      `Time begins the frame Mario appears in the opening cutscene. This is 2.2 seconds after selecting 1 Player Game.`,
      `Time ends on the frame that Peach appears outside of Bowser's Clown Car.`,
      `Complete all 8 castles as quickly as possible.`,
      `No Arbitrary Code Execution.`,
      `No Powerups (Mushroom, Midway Points, Fire Flower, Cape)`,
      `No Yoshi.`
    ],
    penalties: [
      `If any powerup is obtained, or Yoshi is ridden, die as soon as possible without utilizing it.`,
      `If a mushroom is gained by taking an item through the goal tape, die as soon as possible.`,
      `If you grab a checkpoint, take damage as soon as possible, finish the level, and then redo that same exit.`
    ],
    wr: "/category/wk6v75ed?top=1",
    top15: "/category/wk6v75ed?top=15"
  },
  { // nswso
    id: "nswso",
    type: "small-only",
    title: "No Starworld, Small Only",
    desc: `This is the small only variant of No Starworld.`,
    leaderboard: `?h=No_Starworld_Small_Only&x=n2y750e2`,
    route: [
      `Yoshi's Island 2`,
      `Yoshi's Island 3`,
      `Yoshi's Island 4`,
      `#1 Iggy's Castle`,
      `Donut Plains 1 (Secret)`,
      `Donut Secret 1`,
      `Donut Ghost House`,
      `Donut Plains 3`,
      `Donut Plains 4`,
      `#2 Morton's Castle`,
      `Vanilla Dome 1 (Secret)`,
      `Vanilla Secret 1 (Secret)`,
      `Vanilla Secret 2`,
      `Vanilla Secret 3`,
      `Vanilla Fortress`,
      `Butter Bridge 1`,
      `Butter Bridge 2`,
      `#4 Ludwig's Castle`,
      `Forest of Illusion 1`,
      `Forest of Illusion 2`,
      `Forest of Illusion 3 (Secret)`,
      `#5 Roy's Castle`,
      `Chocolate Island 1`,
      `Choco-Ghost House`,
      `Chocolate Island 2 (Secret)`,
      `Chocolate Secret`,
      `#6 Wendy's Castle`,
      `Sunken Ghost Ship`,
      `Valley of Bowser 1`,
      `Valley of Bowser 2 (Secret)`,
      `Valley Fortress`,
      `Back Door`
    ],
    rules: [
      `Time begins the frame Mario appears in the opening cutscene. This is 2.2 seconds after selecting 1 Player Game.`,
      `Time ends on the frame that Peach appears outside of Bowser's Clown Car.`,
      `No Arbitrary Code Execution.`,
      `No Powerups (Mushroom, Midway Points, Fire Flower, Cape)`,
      `No Yoshi.`
    ],
    penalties: [
      `If any powerup is obtained, or Yoshi is ridden, die as soon as possible without utilizing it.`,
      `If a mushroom is gained by taking an item through the goal tape, die as soon as possible.`,
      `If you grab a checkpoint, take damage as soon as possible, finish the level, and then redo that same exit.`
    ],
    wr: "/category/n2y750e2?top=1",
    top15: "/category/n2y750e2?top=15"
  },
  { // small
    id: "small",
    type: "small-only",
    title: "Small Only",
    desc: `This is the small only variant of 11 Exit, however a different path must be taken on the overworld since it is impossible to complete Star World 1 without a Super Mushroom. In all, there are 14 exits to complete in this category.`,
    leaderboard: `?h=Small_Only&x=n2y301do`,
    route: [
      `Yoshi's Island 2`,
      `Yoshi's Island 3`,
      `Yoshi's Island 4`,
      `#1 Iggy's Castle`,
      `Donut Plains 1 (Secret)`,
      `Donut Secret 1`,
      `Donut Ghost House`,
      `Donut Plains 3`,
      `Donut Plains 4`,
      `#2 Morton's Castle`,
      `Vanilla Dome 1 (Secret)`,
      `Vanilla Secret 1 (Secret)`,
      `Star World 2 (Secret)`,
      `Star World 3 (Secret)`,
      `Star World 4 (Secret)`,
      `Front Door`
    ],
    rules: [
      `Time begins the frame Mario appears in the opening cutscene. This is 2.2 seconds after selecting 1 Player Game.`,
      `Time ends on the frame that Peach appears outside of Bowser's Clown Car.`,
      `No Arbitrary Code Execution.`,
      `No Powerups (Mushroom, Midway Points, Fire Flower, Cape)`,
      `No Yoshi.`
    ],
    penalties: [
      `If any powerup is obtained, or Yoshi is ridden, die as soon as possible without utilizing it.`,
      `If a mushroom is gained by taking an item through the goal tape, die as soon as possible.`,
      `If you grab a checkpoint, take damage as soon as possible, finish the level, and then redo that same exit.`
    ],
    wr: "/category/n2y301do?top=1",
    top15: "/category/n2y301do?top=15"
  },
  { // ld
    id: "lunar_d",
    type: "cape",
    title: "Lunar Dragon",
    desc: `This is a variant of 96 Exit that also requires the collection of Dragon Coins and Moons. It is generally done glitchless, although there is a glitched variant. This category has been argued to be the 'true 100%' of SMW, but no such label has been put on the category.`,
    leaderboard: `?h=Lunar_Dragon-Glitchless&x=7dg8zpg2-j84kdwwn.013vw3yl`,
    route: [
      `Yoshi's Island 2`,
      `Yoshi's Island 3`,
      `Yoshi's Island 4`,
      `#1 Iggy's Castle`,
      `Donut Plains 1 (Secret)`,
      `Donut Secret 1`,
      `Donut Ghost House (Secret)`,
      `Donut Secret 1 (Secret)`,
      `Donut Secret House (Secret)`,
      `Donut Secret House`,
      `Donut Secret 2`,
      `Donut Plains 3`,
      `Donut Plains 4`,
      `#2 Morton's Castle`,
      `Vanilla Dome 1`,
      `Vanilla Dome 2 (Secret)`,
      `Red Switch Palace`,
      `Vanilla Dome 2`,
      `Vanilla Ghost House`,
      `Vanilla Dome 3`,
      `Vanilla Dome 4`,
      `#3 Lemmy's Castle`,
      `Cheese Bridge Area`,
      `Cookie Mountain`,
      `Cheese Bridge Area (Secret)`,
      `Soda Lake`,
      `Star World 3 (Secret)`,
      `Star World 4`,
      `Star World 4 (Secret)`,
      `Star World 5`,
      `Star World 1`,
      `Star World 1 (Secret)`,
      `Star World 2 (Secret)`,
      `Star World 3`,
      `Star World 2`,
      `Star World 5 (Secret)`,
      `Gnarly`,
      `Tubular`,
      `Way Cool`,
      `Awesome`,
      `Groovy`,
      `Mondo`,
      `Outrageous`,
      `Funky`,
      `Yoshi's Island 1`,
      `Yellow Switch Palace`,
      `Donut Plains 1`,
      `Donut Plains 2 (Secret)`,
      `Green Switch Palace`,
      `Donut Plains 2`,
      `Donut Ghost House`,
      `Vanilla Dome 1 (Secret)`,
      `Vanilla Secret 1 (Secret)`,
      `Vanilla Secret 1`,
      `Vanilla Secret 2`,
      `Vanilla Secret 3`,
      `Vanilla Fortress`,
      `Butter Bridge 1`,
      `Butter Bridge 2`,
      `#4 Ludwig's Castle`,
      `Forest of Illusion 1`,
      `Forest of Illusion 2 (Secret)`,
      `Blue Switch Palace`,
      `Forest of Illusion 2`,
      `Forest of Illusion 3`,
      `Forest Ghost House (Secret)`,
      `Forest of Illusion 1 (Secret)`,
      `Forest Ghost House`,
      `Forest of Illusion 4 (Secret)`,
      `Forest Secret Area`,
      `Forest Fortress`,
      `Forest of Illusion 4`,
      `Forest of Illusion 3 (Secret)`,
      `#5 Roy's Castle`,
      `Chocolate Island 1`,
      `Choco-Ghost House`,
      `Chocolate Island 2 (Secret)`,
      `Chocolate Secret`,
      `Chocolate Island 2`,
      `Chocolate Island 3`,
      `Chocolate Island 3 (Secret)`,
      `Chocolate Fortress`,
      `Chocolate Island 4`,
      `Chocolate Island 5`,
      `#6 Wendy's Castle`,
      `Sunken Ghost Ship`,
      `Valley of Bowser 1`,
      `Valley of Bowser 2`,
      `Valley Ghost House (Secret)`,
      `Valley Ghost House`,
      `Valley of Bowser 3`,
      `Valley of Bowser 4 (Secret)`,
      `Valley of Bowser 4`,
      `#7 Larry's Castle`,
      `Valley of Bowser 2 (Secret)`,
      `Valley Fortress`,
      `Back Door`
    ],
    rules: [
      `Time begins the frame Mario appears in the opening cutscene. This is 2.2 seconds after selecting 1 Player Game.`,
      `Time ends on the frame that Peach appears outside of Bowser's Clown Car.`,
      `Complete all 96 exits as quickly as possible.`,
      `Collect at least 5 Dragon Coins in levels that have at least 5.`,
      `Collect all Moons.`,
      `No Arbitrary Code Execution.`,
      `No Orb/Cloud.`
    ],
    penalties: [],
    wr: "/category/7dg8zpg2?top=1",
    top15: "/category/7dg8zpg2?top=15"
  }
];

export default CATEGORIES;